import React, { useState } from 'react';
import './CheckboxField.css';
import Field from './Field';

export function CheckboxField(props) {
  const { onCheck, text } = props;
  const [checked, setChecked] = useState(false);
  const checkedClassName = checked ? 'checked' : '';

  const handleClick = () => {
    setChecked(!checked);
    onCheck(text);
  };

  return (
    <Field {...props}>
      <li className={`customCheckboxListItem ${checkedClassName}`} onClick={() => handleClick()}>
        {text}
      </li>
    </Field>
  );
}
